const regionsAndCities = {
  Osrednjeslovenska: [
    "Borovnica",
    "Brezovica",
    "Dobrepolje",
    "Dobrova - Polhov Gradec",
    "Dol pri Ljubljani",
    "Domžale",
    "Grosuplje",
    "Horjul",
    "Ig",
    "Ivančna Gorica",
    "Kamnik",
    "Komenda",
    "Ljubljana",
    "Log - Dragomer",
    "Logatec",
    "Lukovica",
    "Medvode",
    "Mengeš",
    "Moravče",
    "Škofljica",
    "Šmartno pri Litiji",
    "Trzin",
    "Velike Lašče",
    "Vodice",
    "Vrhnika",
  ],
  Gorenjska: [
    "Bled",
    "Bohinj",
    "Cerklje na Gorenjskem",
    "Gorenja vas - Poljane",
    "Gorje",
    "Jesenice",
    "Jezersko",
    "Kranj",
    "Kranjska Gora",
    "Naklo",
    "Preddvor",
    "Radovljica",
    "Šenčur",
    "Škofja Loka",
    "Tržič",
    "Železniki",
    "Žiri",
    "Žirovnica",
  ],
  Podravska: [
    "Benedikt",
    "Cerkvenjak",
    "Cirkulane",
    "Destrnik",
    "Dornava",
    "Duplek",
    "Gorišnica",
    "Hajdina",
    "Hoče - Slivnica",
    "Juršinci",
    "Kidričevo",
    "Kungota",
    "Lenart",
    "Lovrenc na Pohorju",
    "Majšperk",
    "Makole",
    "Maribor",
    "Markovci",
    "Miklavž na Dravskem polju",
    "Oplotnica",
    "Ormož",
    "Pesnica",
    "Podlehnik",
    "Poljčane",
    "Ptuj",
    "Rače - Fram",
    "Ruše",
    "Selnica ob Dravi",
    "Slovenska Bistrica",
    "Središče ob Dravi",
    "Starše",
    "Sveta Ana",
    "Sveta Trojica v Slov. Goricah",
    "Sveti Andraž v Slov. Goricah",
    "Sveti Jurij v Slov goricah",
    "Sveti Tomaž",
    "Šentilj",
    "Trnovska vas",
    "Videm",
    "Zavrč",
    "Žetale",
  ],
  Pomurska: [
    "Apače",
    "Beltinci",
    "Cankova",
    "Črenšovci",
    "Dobrovnik",
    "Gornja Radgona",
    "Gornji Petrovci",
    "Grad",
    "Hodoš/Hodos",
    "Kobilje",
    "Križevci",
    "Kuzma",
    // "Lendava/Lendva",
    // Updated to the client-approved name only.
    "Lendava",
    "Ljutomer",
    "Moravske Toplice",
    "Murska Sobota",
    "Odranci",
    "Puconci",
    "Radenci",
    "Razkrižje",
    "Rogašovci",
    "Sveti Jurij ob Ščavnici",
    "Šalovci",
    "Tišina",
    "Turnišče",
    "Velika Polana",
    "Veržej",
  ],
  Savinjska: [
    "Braslovče",
    "Celje",
    "Dobje",
    "Dobrna",
    "Gornji Grad",
    "Kozje",
    "Laško",
    "Ljubno",
    "Luče",
    "Mozirje",
    "Nazarje",
    "Podčetrtek",
    "Polzela",
    "Prebold",
    "Rečica ob Savinji",
    "Rogaška Slatina",
    "Rogatec",
    "Slovenske Konjice",
    "Solčava",
    "Šentjur",
    "Šmarje pri Jelšah",
    "Šmartno ob Paki",
    "Šoštanj",
    "Štore",
    "Tabor",
    "Velenje",
    "Vitanje",
    "Vojnik",
    "Vransko",
    "Zreče",
    "Žalec",
  ],
  Koroška: [
    "Črna na Koroškem",
    "Dravograd",
    "Mežica",
    "Mislinja",
    "Muta",
    "Podvelka",
    "Prevalje",
    "Radlje ob Dravi",
    "Ravne na Koroškem",
    "Ribnica na Pohorju",
    "Slovenj Gradec",
    "Vuzenica",
  ],
  Goriška: [
    "Ajdovščina",
    "Bovec",
    "Brda",
    "Cerkno",
    "Idrija",
    "Kanal",
    "Kobarid",
    "Miren - Kostanjevica",
    "Nova Gorica",
    "Renče - Vogrsko",
    "Šempeter - Vrtojba",
    "Tolmin",
    "Vipava",
  ],
  "Obalno-kraška": [
    "Ankaran",
    "Divača",
    "Hrpelje - Kozina",
    "Izola",
    "Komen",
    "Koper",
    "Piran",
    "Sežana",
  ],
  Notranjska: [
    "Bloke",
    "Cerknica",
    "Ilirska Bistrica",
    "Loška dolina",
    "Pivka",
    "Postojna",
  ],
  Jugovzhodna: [
    "Črnomelj",
    "Dolenjske Toplice",
    "Kočevje",
    "Kostel",
    "Loški Potok",
    "Metlika",
    "Mirna",
    "Mirna Peč",
    "Mokronog - Trebelno",
    // "Novo Mesto",
    // Updated to the client-approved casing.
    "Novo mesto",
    "Osilnica",
    "Ribnica",
    "Semič",
    "Sodražica",
    "Straža",
    "Šentjernej",
    "Šentrupert",
    "Škocjan",
    "Šmarješke Toplice",
    "Trebnje",
    "Žužemberk",
  ],
  Posavska: [
    "Bistrica ob Sotli",
    "Brežice",
    "Kostanjevica na Krki",
    "Krško",
    "Radeče",
    "Sevnica",
  ],
  Zasavska: ["Hrastnik", "Litija", "Trbovlje", "Zagorje"],
};

export default regionsAndCities;
